import { trackPromise } from 'react-promise-tracker';

export async function registerUser(user) {
    return trackPromise(fetch('https://t41bx8uqf6.execute-api.us-east-2.amazonaws.com/prod/votacion/preregistrar', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'authorizationToken': 'Allow'
        },
        body: JSON.stringify(user)
    }).then(data => data.json()))
}